import React from 'react';
import { Stack, Chip, Typography } from '@mui/material';
import { STATUS_CONFIG } from './SalesDashboard';

const PIPELINE_ORDER = [
  'new_lead', 'contacted', 'qualified', 'application_sent',
  'application_received', 'under_review', 'approved', 'funded',
  'declined_by_bank', 'client_declined_offer',
  'not_interested', 'do_not_call', 'junk',
];

export default function StatusChanger({ currentStatus, onStatusChange }) {
  return (
    <Stack>
      <Typography variant="caption" color="text.secondary" mb={0.5}>Change Status:</Typography>
      <Stack direction="row" gap={0.5} flexWrap="wrap">
        {PIPELINE_ORDER.map((s) => {
          const cfg = STATUS_CONFIG[s];
          const active = currentStatus === s;
          return (
            <Chip
              key={s}
              label={cfg.label}
              size="small"
              onClick={() => !active && onStatusChange(s)}
              sx={{
                bgcolor: active ? cfg.color : cfg.bg,
                color: active ? '#fff' : cfg.color,
                border: `1px solid ${cfg.color}`,
                fontWeight: active ? 700 : 500,
                fontSize: '0.7rem',
                cursor: active ? 'default' : 'pointer',
                '&:hover': active ? {} : { opacity: 0.85 },
              }}
            />
          );
        })}
      </Stack>
    </Stack>
  );
}
